import { useEffect, useCallback, useRef } from 'react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { useEphiStore } from '../store/ephi-store'
import { supabase } from '@/lib/supabase/client'

export function useEphiCount() {
  const { user } = useAuth()
  const { ephiCount, checkEphiCount } = useEphiStore()
  const debounceRef = useRef<NodeJS.Timeout>()

  // Função debounced para verificar ephis
  const debouncedCheckEphiCount = useCallback((userId: string) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
    
    debounceRef.current = setTimeout(() => {
      checkEphiCount(userId)
    }, 300) // 300ms de debounce
  }, [checkEphiCount])

  useEffect(() => {
    if (!user) return

    // Verificar quantidade inicial
    checkEphiCount(user.id)

    // Escutar mudanças na tabela profiles - apenas UPDATEs no ephi_count
    const channel = supabase
      .channel(`ephi-changes-${user.id}`) // Channel único por usuário
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${user.id}`
        },
        (payload) => {
          // Só recarrega se o ephi_count realmente mudou
          if (payload.old?.ephi_count !== payload.new?.ephi_count) {
            debouncedCheckEphiCount(user.id)
          }
        }
      )
      .subscribe()

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
      channel.unsubscribe()
    }
  }, [user?.id, debouncedCheckEphiCount])

  return ephiCount
} 